import { useState } from "react";
import { saveTracking } from "../services/trackingSave";

export const useSaveTracking = () => {
  const [isMutating, setIsMutating] = useState(false);

  const submit = async (args: Parameters<typeof saveTracking>[0]) => {
    setIsMutating(true);
    try {
      await saveTracking(args);
    } finally {
      setIsMutating(false);
    }
  };

  return { submit, isMutating };
};
